<template>
  <div class="selfStudyPage" :class="showTips ? 'selfStudyPage2' : ''">
    <div>
      <van-pull-refresh
        v-model="refreshing"
        style="min-height: 100vh"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="selfStudy">
            <Navbar
              :title="courseObj.name"
              :backNative="true"
              v-if="showTitle"
              style="position: absolute; top: 0; z-index: 9999"
              class="topNav"
            />

            <div class="bg">
              <img
                @click="toNative"
                :style="{ top: statusHeight + 'px' }"
                src="../../assets/images/backIcon.png"
                alt=""
              />
              <div class="courseType">
                <div class="typeInfo" ref="scrollOne">
                  <div class="typeTitle">{{ courseObj.name }}</div>
                  <div class="typeword">{{ courseObj.title }}</div>
                </div>

                <div class="countdown">
                  <div class="countWord">剩余学习时长</div>
                  <countDown
                    color="#FFFFFF"
                    background-color="#FC541E"
                    border-color="#FC541E"
                    padding="0 6px"
                    numberWidth="24px"
                    splitorColor="#fff"
                    :isStart="isStart"
                    @timeup="timeup"
                    :second="courseObj.surplusTime * 1000"
                  >
                  </countDown>
                </div>
              </div>
            </div>

            <div class="content">
              <div class="contentTitle">推荐课程</div>
              <div class="intro">免费课程丨总有适合你的一款</div>
              <div class="courseList">
                <div
                  class="courseCard"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <div class="coursePoster">
                    <img :src="item.cover" alt="" />
                  </div>

                  <div class="cardRight">
                    <div class="courseTitle">{{ item.name }}</div>
                    <div class="learnNum">
                      {{ item.joinCount }}位同学正在学习
                    </div>

                    <div class="courseBt">
                      <div class="teacherInfo">
                        <img
                          :src="
                            item.teacherAvatar
                              ? item.teacherAvatar
                              : require('../../assets/images/default.png')
                          "
                          alt=""
                        />
                        <div class="teachername">{{ item.teacherName }}</div>
                      </div>

                      <div class="learnBt" @click="toLearn(item.id)">
                        开始学习
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="QQ" @click="toQQGroup">
      <img src="../../assets/images/qqGroup.png" alt="" />
      <span>QQ群</span>
    </div>
    <!-- 弹框 -->

    <!-- <div class="learnOver" v-if="showTips" >
          <div class="cardModal">
              <img src="../../assets/images/tips.png" alt="">

              <div class="tipsword">今天的学习时间已经用完啦!</div>
              <div class="tipsword" >请明天再来学习吧~</div>
              <div class="know" @click="showTips=false">我知道了</div>
          </div>
      </div> -->
  </div>
</template>

<script>
import countDown from "../../components/countDown";
import Navbar from "../../components/NavBar";
import http from "../../utils/http";
import { Toast } from "vant";

export default {
  data() {
    return {
      showTitle: false, //是否展示头部标题
      list: [], //列表数据
      loading: false, //是否正在加载
      finished: false, //是否结束
      refreshing: false, //是否正在刷新
      showTips: false, //展示弹框
      current: 1, //当前页码
      size: 20, //每页显示多少条
      courseObj: {}, //自学数据
      surplusTime: "", //自学剩余时间
      init: false,
      isStart: false, //是否开启倒计时
      isNotBand: false, //是否绑定手机号
      num:1
    };
  },
  components: {
    countDown,
    Navbar,
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // this.getCourseList({current:1,size:1})
    this.$nextTick(() => {
      // Toast(this.isInit)
      if (this.isInit) {
        this.initPage();
      }
      // this.initPage()
    });
    // this.initPage();
  },
  activated() {
    this.$nextTick(() => {
      // Toast('2222')
      setTimeout(() => {
        if (this.isInit) {
          this.initPage();
        }
      }, 200);
    });
  },

  computed: {
    isCanLearn() {
      return this.$store.state.canSelfLearn;
    },
    statusHeight() {
      return this.$store.state.statusHeight;
    },
    isInit() {
      return this.$store.state.refreshPage;
    },
  },
  methods: {
    countDownSelf(surplusTime) {
      //自学倒计时
      if (this.modalTimer) {
        clearInterval(this.modalTimer);
      }

      this.seconds = surplusTime;
      if (this.seconds > 0) {
        this.modalTimer = setInterval(() => {
          this.seconds--;
          console.log(this.seconds);
          if (this.seconds <= 0) {
            clearInterval(this.modalTimer);
            this.$store.commit("Set_CanLearn");
          }
        }, 1000);
      } else {
        this.$store.commit("Set_CanLearn");
      }
    },

    initPage() {
      this.init = true;
      if (this.$route.query.id && this.num==1) {
      this.toLearn(this.$route.query.id);
      this.num++
    }
      this.current = 1;
      //  this.list=[]
      this.getCourseList();
    },
    timeup() {
      //倒计时结束

      this.$store.commit("Set_CanLearn");
    },
    //获取列表
    getCourseList() {
      http
        .getClassCourse({ current: this.current, size: this.size, type: 2 })
        .then((res) => {
          // if(this.current==1){
          //   this.list=[]
          // }
          setTimeout(() => {
            if (res.recommendedCourseList.length > 0) {
              if (this.refreshing || this.init) {
                this.list = [...res.recommendedCourseList];
                this.refreshing = false;
                this.init = false;
              } else {
                this.list = [...this.list, ...res.recommendedCourseList];
              }
              if (res.recommendedCourseList.length < 20) {
                this.finished = true;
              }
              this.loading = false;

              this.current++;
            } else {
              this.finished = true;
              this.current--;
            }
          }, 200);

          this.courseObj = res;
          this.surplusTime = res.surplusTime;

          // this.countDownSelf(res.surplusTime)

          if (res.surplusTime <= 0) {
            this.$store.commit("Set_CanLearn");
          }
          //获取用户自学总时长
          http.getUserSelfStudyTime().then((res2) => {
            //  Toast((res.surplusTime==res2.surplusTime)+'')
            if (res.surplusTime < res2.surplusTime) {
              this.isStart = true;
            }
          });
        });
    },
    isCan() {
      //是否能继续学习
      if (!this.isCanLearn) {
        this.$store.commit("Set_ModalVisible", true);
        return false;
      } else {
        return true;
      }
    },
    spikeTimeover() {
      this.showTips = true;
    },
    toQQGroup() {
      http.getQQSetting().then((res) => {
        // console.log(res)
        if (http.deviceType() == "Android") {
          http.guitarAppListener("toQQGroup", res[0]);
        } else {
          http.guitarAppListener("toQQGroup", res[1]);
        }
      });
    },
    toLearn(id) {
      if (this.isCan()) {
        this.$router.push({
          path: "/SelfStudyIntro",
          query: { id, type: 2 },
        }).then(res=>window.PushToken(this.$store.state.token));
      }
    },
    //页面滚动
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let oneHeight = this.$refs.scrollOne.offsetHeight;
      //
      console.log(oneHeight);

      if (scrollTop > oneHeight) {
        //这是滑动到scrollTwo的距离要做的操作
        this.showTitle = true;
      } else {
        this.showTitle = false;
      }
    },
    onLoad() {
      if (this.refreshing) {
      } else {
      }
      this.getCourseList();
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.current = 1;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    toNative() {
      http.guitarAppListener("backToNative", {});
    },
  },
};
</script>

<style lang="less" scoped>
.selfStudyPage {
  position: relative;
  min-height: 100vh;
}
.selfStudy {
  display: flex;
  flex-direction: column;
  position: relative;

  .bg {
    width: 100%;
    height: 174px;
    background: url("../../assets/images/homeWorkBg.png");
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    img {
      width: 22px;
      height: 22px;
      position: absolute;
      top: 14px;
      left: 16px;
    }
    .courseType {
      width: calc(100% - 32px);
      margin: 0 auto;
      margin-top: 76px;
      display: flex;
      justify-content: space-between;
      align-items: "center";
      .typeInfo {
        .typeTitle {
          font-size: 24px;

          font-weight: bold;
          color: #fff;
        }
        .typeword {
          font-size: 13px;
          color: #cacacc;
          margin-top: 4px;
        }
      }
      .countWord {
        font-size: 13px;
        color: #cacacc;
        margin-top: 2px;
        margin-bottom: 6px;
      }
    }
  }

  .content {
    width: 100%;
    flex: 1;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    margin-top: -18px;
    position: relative;
    z-index: 99;
    padding: 0 16px;
    box-sizing: border-box;

    .contentTitle {
      margin-top: 24px;
      font-size: 20px;
      font-weight: bold;
    }
    .intro {
      color: rgba(34, 32, 48, 0.65);
      font-size: 13px;
    }

    .courseList {
      margin-top: 12px;
      .courseCard {
        display: flex;
        width: 100%;
        background: #f6f6f6;
        border-radius: 6px 6px 6px 6px;
        overflow: hidden;
        height: 100px;
        margin-bottom: 8px;

        .coursePoster {
          img {
            width: 100px;
            object-fit: cover;
            height: 100px;
          }
        }
        .cardRight {
          margin-left: 8px;
          flex: 1;
          padding-right: 16px;
          box-sizing: border-box;
        }
        .courseTitle {
          color: #222030;
          font-size: 15px;
          font-weight: bold;
          margin-top: 12px;
        }
        .learnNum {
          font-size: 12px;
          color: rgba(34, 32, 48, 0.45);
          margin-top: 4px;
        }
        .courseBt {
          display: flex;
          justify-content: space-between;
          //   align-items: center;
          //   margin-top: 6px;

          .teacherInfo {
            display: flex;
            align-items: center;
            margin-top: 17px;
            img {
              width: 20px;
              height: 20px;
              object-fit: cover;
              border-radius: 50%;
            }
            .teachername {
              font-size: 12px;
              color: rgba(34, 32, 48, 0.65);
            }
          }

          .learnBt {
            width: 72px;
            margin-top: 6px;
            height: 28px;
            background: linear-gradient(135deg, #ff7337 0%, #fc541e);
            border-radius: 6px;
            font-size: 13px;
            color: #ffffff;
            text-align: center;
            line-height: 29px;
          }
        }
      }
    }
  }
}
.learnOver {
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100vh;
  background: rgba(20, 19, 26, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.cardModal {
  width: 327px;
  height: 203px;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  flex-direction: column;
  img {
    width: 40px;
    height: 40px;
    margin-top: 32px;
    margin-bottom: 24px;
  }
  .tipsword {
    font-size: 15px;
    color: rgba(34, 32, 48, 0.65);
  }
  .know {
    font-size: 16px;
    color: #fc541e;
    margin-top: 29px;
  }
}
.QQ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0px 0px 10px 0px rgba(34, 32, 48, 0.12);
  position: fixed;
  bottom: 24px;
  left: 14px;
  z-index: 999;

  img {
    width: 22px;
    height: 22px;
  }
  span {
    font-size: 10px;
    color: #222030;
  }
}
.selfStudyPage2 {
  height: 100vh;
  overflow: hidden;
}
</style>

